<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="5">
          <township-gp-form @emitTownshipGroupData="createTownshipGroup" />
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
            <township-gp-list :townshipGroups="townshipGroups" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TownshipGpForm from "@/components/township-group/TownshipGpForm";
import TownshipGpList from "@/components/township-group/TownshipGpList";

import { mapState } from "vuex";

export default {
  components: {
    TownshipGpForm,
    TownshipGpList,
  },
  computed: {
    ...mapState("TownshipGroup", ["townshipGroups"]),
  },
  methods: {
    createTownshipGroup(data) {
      this.$store.dispatch("TownshipGroup/createTownshipGroup", data);
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroups");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
